/* eslint-disable no-console */
import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import {
  MSAL_BASE_URL,
  MSAL_CLIENT_ID,
  MSAL_POSTLOGOUT_REDIRECTION_URI,
  MSAL_REDIRECTION_URI,
  MSAL_TENANT_NAME,
} from 'core/constants/general.constants';
import { isProduction } from './env';

const config: Configuration = {
  auth: {
    clientId: MSAL_CLIENT_ID,
    authority: `https://${MSAL_BASE_URL}/${MSAL_TENANT_NAME}.onmicrosoft.com/b2c_1a_insuma_signin`,
    knownAuthorities: [`${MSAL_BASE_URL}`],
    redirectUri: MSAL_REDIRECTION_URI,
    postLogoutRedirectUri: MSAL_POSTLOGOUT_REDIRECTION_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    allowNativeBroker: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii || isProduction()) {
          return;
        }
        // eslint-disable-next-line default-case
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
        }
      },
    },
  },
};

const msalPublicClientApplication = new PublicClientApplication(config);

export default msalPublicClientApplication;
